export const TemplateType = {
    HTML5: "HTML5",
    PSD: "PSD",
    AE: "AE",
    INDESIGN: "INDESIGN",
} as const;
